export class MongoAtlasOidc {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpServiceAccountUniqueId",
            "baseName": "gcpServiceAccountUniqueId",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpRestoreServiceAccountUniqueId",
            "baseName": "gcpRestoreServiceAccountUniqueId",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureIssuerUri",
            "baseName": "azureIssuerUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureAudience",
            "baseName": "azureAudience",
            "type": "string",
            "format": ""
        },
        {
            "name": "azurePrincipal",
            "baseName": "azurePrincipal",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenResource",
            "baseName": "tokenResource",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasOidc.attributeTypeMap;
    }
    constructor() {
    }
}
